import { constants } from "@newsela/angelou";

const { colors } = constants;

export const toastCss = {
  marginTop: "16px",
};

export const toastLinkCss = {
  color: colors.ui.white[700],
  padding: "0 0 0 5px",
};
